import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { getAppIntegrationContract } from "../-query/api";
import { appIntegrationKey } from "../-query/key";

import { TAB_FILTER } from "./-constants";
import { SearchSchema } from "./-zod-schema";

export const Route = createFileRoute(
  "/_staff/app-integrations/$id/_$id/users/",
)({
  validateSearch: zodValidator(SearchSchema),
  loaderDeps: ({ search }) => ({ search }),
  beforeLoad: async ({ params, search, context }) => {
    // categoryが既に指定されている場合は何もしない
    if (search.category !== undefined) {
      return;
    }

    // アプリ情報を取得してisSubordinateをチェック
    // ensureQueryDataを使用してキャッシュを活用し、API二重呼び出しを防ぐ
    const appContract = await context.queryClient.ensureQueryData({
      queryKey: appIntegrationKey.contract(params.id),
      queryFn: () => getAppIntegrationContract(params.id),
    });
    const isSubordinate = appContract.isSubordinate;

    // is_subordinate: trueの場合はデフォルトをALLに、falseの場合はFOLLOWINGに
    const defaultCategory = isSubordinate
      ? TAB_FILTER.ALL
      : TAB_FILTER.FOLLOWING;

    // デフォルトカテゴリにリダイレクト
    throw redirect({
      to: ".",
      search: {
        ...search,
        category: defaultCategory,
      },
    });
  },
});
